import ContactCard from "./ContactCard";
import { H1 } from "@verse_core/shared_components/base/TextComponents/H1";
import { P1 } from "@verse_core/shared_components/base/TextComponents/P1";
import { P2 } from "@verse_core/shared_components/base/TextComponents/P2";
import { PROVIDER_PORTAL_MAIN_COLUMN_CLASS } from "./util/providerPortalMainColumn";
import { rebrandEnabled } from "./util/brandingFlag";

/**
 * Contact Us page for the DMEPOS partner portal.
 *
 * A header, then four contact cards: health plan orders, mail order referrals,
 * heavy DMEPOS referrals, and patient questions.
 */
const ContactUsDME = () => {
  const rebrand = rebrandEnabled();
  return (
    <div
      className={`${PROVIDER_PORTAL_MAIN_COLUMN_CLASS} tw-flex tw-min-h-[603px] tw-flex-col tw-py-[72px]`}
    >
      <div className="tw-mb-[32px] tw-flex tw-items-center tw-rounded-lg tw-bg-gray-light-3 tw-p-[24px]">
        <img
          src={rebrand ? "/rebranded/verse_crew.png" : "/verse_crew.png"}
          alt="Description"
          className="tw-h-[172px] tw-w-[260px]"
        />
        <div className="tw-flex tw-flex-col tw-justify-center">
          <H1 className="tw-mb-[16px] tw-font-domine">
            Support for DMEPOS suppliers
          </H1>
          <P2 className="tw-font-medium tw-text-gray-2">
            We're excited to work with you in our pursuit to provide a seamless
            and reliable in-home care experience for clinicians and patients.
          </P2>
        </div>
      </div>
      <div className="tw-flex tw-flex-wrap tw-gap-[24px]">
        <ContactCard
          title="Support for Health Plan Orders"
          email="supplier-partners@versemedical.com"
          phoneNumber="(888) 247-0790"
          className="tw-w-full lg:tw-w-[calc(33.333%-16px)]"
        />
        <ContactCard
          title="Support for Mail Order Referrals"
          email="partners@versemedical.com"
          className="tw-w-full lg:tw-w-[calc(33.333%-16px)]"
        >
          <P1 className="tw-mb-0">
            Submit Support Requests{" "}
            <a
              href="https://forms.gle/oR98kXmMXrKtois68"
              className="tw-text-blue-1 tw-underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </P1>
        </ContactCard>
        <ContactCard
          title="Support for Heavy DMEPOS Referrals"
          email="referrals@versemedical.com"
          phoneNumber="(888) 247-0790"
          className="tw-w-full lg:tw-w-[calc(33.333%-16px)]"
        />
        <ContactCard
          title="If a patient reaches out to you with questions about their order, please ask them to contact"
          email="patient-support@versemedical.com"
          phoneNumber="(833) 518-1613, option 1"
          textNumber="(205) 627-7400 (Text only)"
          className="tw-w-full lg:tw-w-[calc(33.333%-16px)] lg:tw-max-w-[calc(33.333%-16px)] lg:tw-grow-0"
        />
      </div>
    </div>
  );
};

export default ContactUsDME;
